import { useEffect } from 'react';

export const usePreventBodyScroll = (dependencie) => {
  useEffect(() => {
    if (dependencie) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [dependencie]);
};
